<p-confirmdialog></p-confirmdialog>

<div class="delegacias-container">
    @if (carregamentoInicialListaDelegacias()) {
        <div class="flex justify-center items-center py-8 min-h-[160px]">
            <p-progressSpinner aria-label="Carregando lista de delegacias"></p-progressSpinner>
        </div>
    }

    <app-card-content icon="pi pi-building" title="Delegacias">
        <div card-header>
            @if (temPermissaoEdicao()) {
                <p-button label="Adicionar Delegacia" icon="pi pi-plus-circle" (onClick)="abrirCadastroDelegacia()" [appCan]="PERMISSOES.orgaos.delegacias.criar" [appCanUf]="uf()"></p-button>
            }
        </div>

        <app-custom-table
            [data]="delegacias"
            [metadata]="delegaciasMetadata()"
            [columnOrder]="delegaciasColumnOrder"
            [showActions]="true"
            [loading]="carregandoLista"
            [showExpandButton]="false"
            [initialViewMode]="initialViewMode()"
            [rows]="10"
            [totalRecords]="delegacias.length"
            [permissaoUf]="uf()"
        >
        </app-custom-table>
    </app-card-content>
</div>

<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Dados e abrangência da delegacia." [header]="tituloDialogDelegacia" [(visible)]="displayDelegaciaDialog" [style]="{ width: '680px', maxWidth: '95vw' }">
    <form [formGroup]="formDelegacia" class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
        <div class="flex flex-col gap-1.5">
            <label for="delegaciaUf" class="font-semibold">UF *</label>
            <input id="delegaciaUf" pInputText formControlName="uf" class="w-full" readonly />
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaSigla" class="font-semibold">Sigla *</label>
            <input id="delegaciaSigla" pInputText formControlName="sigla" class="w-full" maxlength="10" />
        </div>

        <div class="md:col-span-2 flex flex-col gap-1.5">
            <label for="delegaciaDescricao" class="font-semibold">Delegacia *</label>
            <input id="delegaciaDescricao" pInputText formControlName="descricao" class="w-full" maxlength="150" />
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaCnpj" class="font-semibold">CNPJ *</label>
            <p-inputMask id="delegaciaCnpj" mask="99.999.999/9999-99" formControlName="registro" class="w-full"></p-inputMask>
        </div>

        <div class="flex flex-col gap-1.5">
            <label for="delegaciaSituacao" class="font-semibold">Situação *</label>
            <p-select id="delegaciaSituacao" [options]="situacoes" formControlName="situacao" optionLabel="label" optionValue="value" placeholder="Selecione a situação" class="w-full" appendTo="body"></p-select>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-3 pt-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="displayDelegaciaDialog = false"></p-button>
            <p-button [label]="labelBotaoSalvarDelegacia" icon="pi pi-check" [loading]="salvandoDelegacia" (onClick)="salvarDelegacia()"></p-button>
        </div>
    </ng-template>
</p-dialog>
